import { ErrorBaseData } from '.'

export const attendanceErrors: Record<string, ErrorBaseData> = {
  AttendanceAlreadyFinishedException: {
    message: 'Atendimento já finalizado',
    description: 'Este atendimento já foi finalizado',
  },
  AttendanceAlreadyOngoingException: {
    message: 'Atendimento em andamento',
    description: 'Já existe um atendimento em andamento para a patologia selecionada',
  },
  AttendanceNotFoundException: {
    message: 'Atendimento não encontrado',
    description: 'Não foi possível encontrar o atendimento. Verifique as informações e tente novamente',
  },
  AttendanceQuestionNotFoundException: {
    message: 'Pergunta não encontrada',
    description: 'Não foi possível encontrar a pergunta do atendimento. Verifique as informações e tente novamente',
  },
  AttendanceCalculatorNotFoundException: {
    message: 'Calculadora não encontrada',
    description: 'Essa calculadora não faz parte do atendimento. Verifique as informações e tente novamente',
  },
  AttendanceUnrelatedQuestionException: {
    message: 'Questão não encontrada',
    description: 'Essa questão não faz parte do atendimento. Verifique as informações e tente novamente',
  },
  AttendanceWasCanceledException: {
    message: 'Atendimento cancelado',
    description: 'Esse atendimento foi cancelado. Verifique as informações e tente novamente',
  },
  CannotUpdateAttendanceCalculator: {
    message: 'Erro ao responder a calculadora',
    description: 'Não foi possível atualizar a resposta da calculadora. Verifique as informações e tente novamente',
  },
}
